import { render, staticRenderFns } from "./AddAssetChoice.vue?vue&type=template&id=65d6417c&scoped=true&"
import script from "./AddAssetChoice.vue?vue&type=script&lang=js&"
export * from "./AddAssetChoice.vue?vue&type=script&lang=js&"
import style0 from "./AddAssetChoice.vue?vue&type=style&index=0&id=65d6417c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6417c",
  null
  
)

export default component.exports